"use client";

const DarkMysticalDivider = () => (
  <div className="flex items-center justify-center mt-12 mb-12 w-full max-w-5xl mx-auto">
    <div className="flex-grow border-t border-[#A45DE8]/40"></div>
    <span
      className="mx-4 text-2xl md:text-3xl select-none text-[#A45DE8]"
      aria-hidden="true"
      style={{
        textShadow: '0 0 12px #A45DE8, 0 0 24px #D4B6FF',
        display: 'inline-block',
        animation: 'mystical-spin 7s cubic-bezier(0.77,0,0.18,1) infinite',
      }}
    >
      ✧
    </span>
    <div className="flex-grow border-t border-[#A45DE8]/40"></div>
  </div>
);

export default DarkMysticalDivider; 